import React from "react";
import { connect } from "react-redux";
import styles from "./data-card.module.scss";
import DataCardRow from "../../components/data-card-row";
import { dataMapper, dataComparisonMapper } from "../../helpers/data-mapper";
import { findDOMNode } from "react-dom";
import ScrollToComponent from "../../helpers/scroll-to-component";
import * as selectors from "../../reducers";
import PropTypes from "prop-types";
import { colorMatcher } from "../../helpers/formatters";

class DataCard extends React.Component {
  constructor() {
    super();
    this.rows = {};
    this.state = {
      expanded: false,
      expandable: true,
      heights: {
        collapsed: 1000,
        expanded: 4200,
      },
    };
    this.handleExpandClick = this.handleExpandClick.bind(this);
  }

  redrawCards() {
    const { isMobile } = this.props;
    const expandable = Object.keys(this.rows).length > 1;
    let expanded = this.cardElement.scrollHeight;
    let whichRow = this.rows[0];
    const node = findDOMNode(whichRow).querySelectorAll(".barChart")[1];

    let offset = this.props.comparedCouncil ? 40 : 10;
    if (!isMobile) {
      // :(
      const marginTop = parseInt(window.getComputedStyle(node).marginTop, 10);
      offset = offset + node.scrollHeight + marginTop;
    }

    const collapsed = node.offsetTop + offset;

    this.setState({
      heights: {
        expanded,
        collapsed,
      },
    });
    if (!expandable) {
      this.setState({
        expanded: true,
        expandable: false,
      });
    }
  }

  componentDidUpdate(prevProps) {
    // We need to redraw the cards with their new heights when
    // we switch from comparison to single view.
    if (prevProps.comparedCouncil && !this.props.comparedCouncil) {
      this.redrawCards();
    }
  }

  componentDidMount() {
    this.redrawCards();
  }

  buildRowArray(id) {
    const { activeCouncil, councils } = this.props;
    const sameClassificationCouncils = councils.filter(
      (council) =>
        council.classification === activeCouncil.classification &&
        !council.isBlank
    );

    const statesCouncils = councils.filter((council) => !council.isBlank);

    const ret = dataMapper({
      activeCouncil: activeCouncil[id],
      classification: sameClassificationCouncils.map((council) => council[id]),
      state: statesCouncils.map((council) => council[id]),
    });
    return ret;
  }

  buildRowArrayForComparison(id) {
    const { activeCouncil, comparedCouncil, councils } = this.props;
    const classification = councils.filter((council) => {
      return (
        (council.classification === activeCouncil.classification ||
          council.classification === comparedCouncil.classification) &&
        !council.isBlank
      );
    });
    const statesCouncils = councils.filter((council) => !council.isBlank);

    return dataComparisonMapper({
      activeCouncil: activeCouncil[id],
      comparedCouncil: comparedCouncil[id],
      classification: classification.map((council) => council[id]),
      state: statesCouncils.map((council) => council[id]),
    });
  }

  renderDataCardRows(id, color, label) {
    const { comparedCouncil } = this.props;
    const { expanded, expandable } = this.state;
    const rowData = comparedCouncil
      ? this.buildRowArrayForComparison(id)
      : this.buildRowArray(id);
    const howManyRowsToShow = expandable ? (expanded ? 9999 : 1) : 1;
    return (
      <div>
        {rowData
          // Only show rows for which there is meaningful data
          .filter((row) => {
            return row.data.total || row.data[0].value !== "";
          })
          .map((row, i) => {
            return (
              <DataCardRow
                key={i}
                data={row}
                color={color}
                revealed={i < howManyRowsToShow}
                ref={(r) => (this.rows[i] = r)}
                cardTitle={label}
                isCardExpanded={expanded}
              />
            );
          })}
      </div>
    );
  }

  renderExpandButton() {
    return (
      <div
        className={styles.dataCardExpandContainer}
        onClick={this.handleExpandClick}
        data-expanded={this.state.expanded}
        data-expandable={this.state.expandable}
        data-color={this.props.color}
      >
        <button type="button" className={styles.dataCardExpandContainerButton}>
          {this.state.expanded ? "Hide breakdown -" : "View breakdown +"}
        </button>
      </div>
    );
  }

  handleExpandClick() {
    const { expanded, expandable } = this.state;
    if (expandable) {
      // We're now opening, let's scroll
      if (!expanded) {
        ScrollToComponent(this);
      } else {
        ScrollToComponent(this, true);
      }
      this.setState({
        expanded: !expanded,
      });
    }
  }

  render() {
    const { id, color, label } = this.props;
    const { expanded, expandable, heights } = this.state;
    const cardHeight = expanded ? heights.expanded + 20 : heights.collapsed;

    let transitionTime = expanded
      ? heights.expanded * 0.2
      : heights.expanded * 0.1;
    let transition = `max-height ${transitionTime}ms`;
    return (
      <div
        className={styles.dataCard}
        style={{ maxHeight: cardHeight, transition }}
        ref={(r) => (this.cardElement = r)}
        data-expanded={expanded}
        data-expandable={expandable}
        data-color={color}
      >
        <div className={styles.dataCardHeader}>
          {label}
          <hr
            className={styles.line}
            style={{ background: colorMatcher(color) }}
          />
        </div>
        {this.renderDataCardRows(id, color, label)}
        {this.renderExpandButton()}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  activeCouncil: selectors.getActiveCouncil(state),
  comparedCouncil: selectors.getComparedCouncil(state),
  councils: selectors.getCouncils(state),
  isMobile: selectors.getIsMobile(state),
});

DataCard.propTypes = {
  activeCouncil: PropTypes.object.isRequired,
  comparedCouncil: PropTypes.object,
  id: PropTypes.string.isRequired,
};

export default connect(mapStateToProps, null)(DataCard);



// WEBPACK FOOTER //
// ./src/components/data-card/data-card.js